module.exports = __webpack_public_path__ + "img/logo-ward.2f86eb88.jpg";